<script lang="ts">
import { useDisplay } from 'vuetify'

export default {
    name: 'NavigationSidebar',
    props: {
        rail: { type: Boolean, required: true },
    },
    emits: ['mobileMode'],
    data() {
        const { mobile } = useDisplay()
        return {
            hover: false,
            mobile,
        }
    },
    computed: {
        isLoggedIn() {
            return this.$currentUser().k
        },
    },
    methods: {
    },
}
</script>

<template>
    <div @mouseover="hover = true" @mouseleave="hover = false">
        <v-list-item nav>
            <div class="w-100 text-center">
                <img v-if="!rail || hover" src="@/assets/images/logo-cleaned.png" alt="Logo Serpic" width="100">
                <img v-else src="@/assets/images/logo-alone.png" alt="Logo Serpic" width="30" class="py-2">
            </div>
        </v-list-item>

        <v-divider />

        <v-list density="compact" nav>
            <NuxtLink to="/">
                <v-list-item prepend-icon="mdi mdi-application-outline" value="home">
                    <v-list-item-title>Accueil</v-list-item-title>
                </v-list-item>
            </NuxtLink>

            <v-list-subheader v-if="$hasOnePermissionCheck([`dashboard_page`, 'declaration_page', 'changeLog_page'])" class="text-uppercase mt-5">
                Déclarations
            </v-list-subheader>

            <NuxtLink v-if="$permissionCheck(`dashboard_page`)" to="/tableau-de-bord">
                <v-list-item prepend-icon="mdi-view-dashboard" value="dashboard">
                    <v-list-item-title>Tableau de bord</v-list-item-title>
                </v-list-item>
            </NuxtLink>

            <NuxtLink v-if="$permissionCheck(`declaration_page`)" to="/declarations">
                <v-list-item prepend-icon="mdi-file-multiple" value="declarations">
                    <v-list-item-title>Déclarations</v-list-item-title>
                </v-list-item>
            </NuxtLink>

            <NuxtLink v-if="$permissionCheck(`changeLog_page`)" to="/journal-des-modifications">
                <v-list-item prepend-icon="mdi-history" value="historique">
                    <v-list-item-title>Journal des modifications</v-list-item-title>
                </v-list-item>
            </NuxtLink>

            <!-- BURNS -->
            <v-list-subheader v-if="$hasOnePermissionCheck([`notificationAlert_page`, 'declaration_burn_page', 'declarationSpecialeSdis_page', 'dashboard_burn_page'])" class="text-uppercase mt-5">
                Brûlages
            </v-list-subheader>
            <NuxtLink v-if="$permissionCheck(`dashboard_burn_page`)" to="/tableau-de-bord-brulages">
                <v-list-item prepend-icon="mdi-view-dashboard" value="dashboard-sdis">
                    <v-list-item-title>Tableau de bord brûlages</v-list-item-title>
                </v-list-item>
            </NuxtLink>
            <NuxtLink v-if="$permissionCheck(`declarationSpecialeSdis_page`)" to="/declarations-speciales-sdis">
                <v-list-item prepend-icon="mdi-file-multiple" value="declarations-speciales-sdis">
                    <v-list-item-title>Déclarations SDIS</v-list-item-title>
                </v-list-item>
            </NuxtLink>
            <NuxtLink v-if="$permissionCheck(`declaration_burn_page`)" to="/carte-brulages">
                <v-list-item prepend-icon="mdi-map" value="carte-brulages">
                    <v-list-item-title>Carte des brûlages</v-list-item-title>
                </v-list-item>
            </NuxtLink>
            <NuxtLink v-if="$permissionCheck(`notificationAlert_page`)" to="/notifications-alertes">
                <v-list-item prepend-icon="mdi-bell-cog" value="notifications">
                    <v-list-item-title>
                        {{ $t('notificationAlert.index') }}
                    </v-list-item-title>
                </v-list-item>
            </NuxtLink>

            <!-- <div v-if="isLoggedIn && $isAdmin()"> -->
            <div>
                <v-list-subheader v-if="$hasOnePermissionCheck([`organization_page`, 'user_page'])" class="text-uppercase mt-5">
                    Administration
                </v-list-subheader>
                <NuxtLink v-if="$permissionCheck(`organization_page`)" to="/organismes">
                    <v-list-item prepend-icon="mdi mdi-city-switch" value="organismes">
                        <v-list-item-title>Territoires</v-list-item-title>
                    </v-list-item>
                </NuxtLink>
                <NuxtLink v-if="$permissionCheck(`user_page`)" to="/utilisateurs">
                    <v-list-item prepend-icon="mdi mdi-account-multiple" value="utilisateurs">
                        <v-list-item-title>Utilisateurs</v-list-item-title>
                    </v-list-item>
                </NuxtLink>
                <NuxtLink v-if="$permissionCheck(`configuration_index`)" to="/configuration">
                    <v-list-item prepend-icon="mdi mdi-cog" value="configuration">
                        <v-list-item-title>Paramètres</v-list-item-title>
                    </v-list-item>
                </NuxtLink>
                <NuxtLink
                    v-if="$permissionCheck('mapService_page')"
                    to="/services-cartographiques"
                >
                    <v-list-item
                        prepend-icon="mdi mdi-map-legend"
                        value="servicescarto"
                    >
                        <v-list-item-title>Services cartographiques</v-list-item-title>
                    </v-list-item>
                </NuxtLink>
                <NuxtLink
                    v-if="$permissionCheck('mapLayer_page')"
                    to="/couches-cartographiques"
                >
                    <v-list-item
                        prepend-icon="mdi mdi-layers-triple"
                        value="couchescarto"
                    >
                        <v-list-item-title>Couches cartographiques</v-list-item-title>
                    </v-list-item>
                </NuxtLink>
                <NuxtLink v-if="$isAdmin()" to="/circuit-de-validation">
                    <v-list-item
                        prepend-icon="mdi mdi-sitemap-outline"
                        value="circuitdevalidation"
                    >
                        <v-list-item-title>Circuit de validation</v-list-item-title>
                    </v-list-item>
                </NuxtLink>
                <a v-if="$isAdmin()" href="https://gitlab.com/datakode/serpic2/-/releases" target="_blank">
                    <v-list-item
                        prepend-icon="mdi-note-text-outline"
                        value="versions"
                    >
                        <v-list-item-title>Notes de version</v-list-item-title>
                    </v-list-item>
                </a>
                <v-list-item v-if="mobile" prepend-icon="mdi-sync">
                    <v-list-item-title>
                        <p @click="$emit('mobileMode')">
                            Voir l'affichage mobile
                        </p>
                    </v-list-item-title>
                </v-list-item>
            </div>
        </v-list>
    </div>
</template>
